// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyContentStub__container-f430af {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  padding: 0 20px;
  text-align: center;
  height: 100%;
  margin: auto 0;
}

.EmptyContentStub__img-ec94cc {
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/SharedData/components/EmptyContentStub/EmptyContentStub.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n  padding: 0 20px;\n  text-align: center;\n  height: 100%;\n  margin: auto 0;\n}\n\n.img {\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EmptyContentStub__container-f430af`,
	"img": `EmptyContentStub__img-ec94cc`
};
module.exports = ___CSS_LOADER_EXPORT___;
